module.exports = __webpack_public_path__ + "static/media/rw-logo-white.235ef22d.svg";